/**
 * Zentrale Tenant-ID für die gesamte Anwendung
 */
export const TENANT_ID = "1gcJ4fmP4m";

// Legacy Export für Kompatibilität
export const DEFAULT_TENANT_ID = TENANT_ID;
